/* Manu AI v21 (22/10/2026) — image jointe depuis l'accueil.
 * Accueil : « + Image » avec un champ vide ne lance plus la conversation. L'image reste dans la carte (miniature + Retirer),
 * le champ prend le focus, et Manu s'ouvre seulement quand le visiteur valide avec son texte.
 * Avec un texte déjà écrit, ou sans serveur (mode démo), le comportement de v12 est inchangé.
 * (La planche de choix des zones de la v21 d'origine est remplacée par le placement libre sur mockup : assets/ai-studio-v24.js.)
 * S'appuie sur l'instance de assets/ai-studio.js (section._ais), enrichie par v9 → v20, chargés avant. */
(function () {
  'use strict';

  var HERO = {
    fr: { rm: 'Retirer l’image', ph: 'Dis à Manu ce que tu veux faire de cette image…', ask: 'Écris ce que tu veux faire de l’image (la copier, changer un nom, t’en inspirer…), puis valide.' },
    en: { rm: 'Remove the image', ph: 'Tell Manu what you want to do with this image…', ask: 'Write what you want to do with the image (copy it, change a name, take inspiration…), then confirm.' },
    es: { rm: 'Quitar la imagen', ph: 'Dile a Manu qué quieres hacer con esta imagen…', ask: 'Escribe qué quieres hacer con la imagen (copiarla, cambiar un nombre, inspirarte…) y confirma.' },
    de: { rm: 'Bild entfernen', ph: 'Sag Manu, was er mit diesem Bild machen soll …', ask: 'Schreib, was du mit dem Bild vorhast (kopieren, einen Namen ändern, Inspiration …), und bestätige.' },
    it: { rm: 'Rimuovi l’immagine', ph: 'Dì a Manu cosa vuoi fare con questa immagine…', ask: 'Scrivi cosa vuoi fare con l’immagine (copiarla, cambiare un nome, ispirarti…), poi conferma.' }
  };
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- Image jointe depuis l'accueil : on n'ouvre la conversation qu'avec un texte ---------- */
  function hero(inst) {
    var baseHero = inst.heroImage, form = inst.form, field = inst.ideaField;
    if (inst._v21h || !baseHero || !form || !field) return;
    inst._v21h = true;
    var h = HERO[inst.loc] || HERO.en, pend = null, chip = null, ph0 = '';
    var X = '<svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

    function clear() {
      if (chip) { if (chip._u) { try { URL.revokeObjectURL(chip._u); } catch (e) {} } if (chip.parentNode) chip.parentNode.removeChild(chip); }
      if (pend && ph0) field.placeholder = ph0;
      chip = null; pend = null;
    }
    function valid(file) { return (/^image\/(png|jpe?g|webp|svg\+xml)$/i.test(file.type) || /\.svg$/i.test(file.name)) && file.size <= 15 * 1024 * 1024; }

    inst.heroImage = function (file) {
      var idea = field.value.trim();
      // Texte déjà écrit, mode démo ou fichier refusé : comportement d'origine (v12)
      if (idea || !this.endpoint || !valid(file)) { clear(); return baseHero.call(this, file); }
      clear();
      pend = file; ph0 = field.placeholder;
      var url = ''; try { url = URL.createObjectURL(file); } catch (e) {}
      chip = document.createElement('div');
      chip.className = 'ais-heroimg'; chip._u = url;
      chip.innerHTML = '<div class="ais-heroimg__row">' + (url ? '<img alt="" src="' + esc(url) + '">' : '') +
        '<span class="ais-heroimg__n">' + esc(file.name) + '</span>' +
        '<button type="button" class="ais-heroimg__x" aria-label="' + esc(h.rm) + '">' + X + '</button></div>' +
        '<p class="ais-heroimg__hint" role="status" hidden></p>';
      field.parentNode.insertBefore(chip, field);
      chip.querySelector('.ais-heroimg__x').addEventListener('click', function () { clear(); field.focus(); });
      field.placeholder = h.ph;
      field.focus();
    };

    // Capture : passe avant l'écouteur d'origine (qui ouvrirait Manu ou remplirait un exemple)
    form.addEventListener('submit', function (e) {
      if (!pend) return;
      e.preventDefault(); e.stopImmediatePropagation();
      if (!field.value.trim()) {
        var p = chip && chip.querySelector('.ais-heroimg__hint');
        if (p) { p.textContent = h.ask; p.hidden = false; }
        field.focus();
        return;
      }
      var f = pend; clear(); inst.heroImage(f);
    }, true);
  }

  function enhance(root) {
    var inst = root._ais;
    if (!inst) return;
    hero(inst);
  }

  function boot() { document.querySelectorAll('[data-ais]').forEach(enhance); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function () { setTimeout(boot, 0); });
})();
